import { useEffect, useState } from "react";
import {calculateWTLoss} from "../../../api/sensorApi";
import { toast } from "react-toastify";


function useFetchWtloss(sensorID, start, end,) {

    const [WTLossData, setWTLossData] = useState({
        wtloss: null,
        start: null,
        end: null,
    });

    const [error, setError] = useState(null);

    useEffect(() => {
        calculateWTLoss({
            sensor_id: sensorID,
            start: start?.toISOString()?.split('T')[0],
            end: end?.toISOString()?.split('T')[0],
        }).then((res) => {
            console.log(res)
            setWTLossData({
                wtloss: res?.wtloss,
                start: res?.start,
                end: res?.end,
            });
        }).catch((error) => {
            toast.error("Error fetching WTLoss data");
            console.error(error);
        });
    }, [sensorID, start, end,]);


    return { WTLossData, error };
}

export default useFetchWtloss;